<template>
  <div width="100%" class="ma-2">
    <v-row>
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <v-overlay :value="overlay">
          <div class="my-2">
            <v-progress-circular
              color="indigo"
              :size="120"
              indeterminate
              :width="20"
            >
            </v-progress-circular>
          </div>
          <span style="font-size: 20px"><b>Caricamento in corso..</b></span>
        </v-overlay>
        <v-card style="min-height: 500px">
          <v-toolbar class="indigo white--text" dense primary-title>
            <v-toolbar-title>Converti pdf in csv</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  :disabled="loading || files.length == 0"
                  small
                  @click="fileUpload()"
                >
                  <v-icon style="color: #1a80b6">mdi-file-upload</v-icon>
                </v-btn>
              </template>
              <span>Upload File</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loading"
                  @click="goBack"
                  small
                >
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row class="justify-center">
                <v-col cols="10">
                  <v-file-input
                    outlined
                    dense
                    accept="application/pdf"
                    hide-details
                    v-model="files"
                    multiple
                  />
                  <v-progress-linear
                    v-if="loading"
                    id="progress"
                    v-model="value"
                    style="height: 25px"
                  >
                    <span>Upload in corso.. {{ this.value }}/100</span>
                  </v-progress-linear>
                </v-col>
              </v-row>
              <div v-if="nomi_file.length > 0">
                <v-col
                  class="pb-0 pt-1"
                  v-for="(nome, idNomi) in nomi_file"
                  :key="idNomi"
                >
                  <v-chip>{{ nome["file_path"] }}</v-chip>
                </v-col>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3"></v-col>
    </v-row>

    <SnackbarQV ref="snackbarqv" />
  </div>
</template>
<script>
import axios from "axios";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import { saveAs } from "file-saver";

export default {
  name: "PDFOMP",
  components: {
    SnackbarQV,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    rotta_back: {
      type: String,
      default: "/home/dashboard",
    },
  },
  data() {
    return {
      // Variabili di supporto
      codice_search: "",
      value: 0,

      // Array
      array_diff_ordini: [],
      codici_ordini: [],
      diff_ordini: [],
      files: [],
      nomi_file: [],
      pdfFiles: [],
      showContent: [],

      // Modal
      caricamento_dati: false,
      compare_files: false,
      loading: false,
      singleFile: false,
      uploadNewFiles: false,
      color: null,
      interval: null,
      overlay: false,
    };
  },
  mounted() {
    //this.getFiles();
  },
  methods: {
    // apriDettaglioFile(item) {

    // },
    chiudiCompareDialog() {
      this.compare_files = false;
      this.getFiles();
    },
    closeDialog() {
      this.getFiles();
      this.uploadNewFiles = false;
      this.array_diff_ordini = [];
      this.showContent = Array.from([]);
    },
    chiudiVisualizzaPdf() {
      this.singleFile = false;
    },
    async fileUpload() {
      if (this.files.length === 0) {
        return;
      }
      this.overlay = true;
      let form_data = new FormData();
      this.loading = true;
      //inserisco i file con nome_file = primarykey.estensione
      this.files.forEach((ele) => {
        form_data.append("file" + this.files.indexOf(ele), ele);
      });
      if (this.files.length != 0) {
        new Promise((resolve, reject) => {
          axios
            .post(
              this.$store.state.config.ip + "api/Global/pdf_to_csv",
              form_data,
              {
                responseType: "arraybuffer",
                headers: { Token: localStorage.user_token },
              },
              {
                onUploadProgress: (progressEvent) => {
                  let progress = Math.round(
                    (progressEvent.loaded / progressEvent.total) * 100
                  );
                  this.value = progress;
                },
              }
            )
            .then((result) => {
              this.overlay = false;
              if (result.status === 200) {
                let headers = result.headers;
                const blob = new Blob([result.data], { type: "octet/stream" });
                this.files = [];
                this.loading = false;
                console.log("res:",result);
                saveAs(blob, headers["filename"]);
              } else {
                this.$refs.snackbarqv.print(
                  "Orange",
                  `Criticità rilevata: codice ${result.status}.`
                );
              }
            })
            .catch((err) => {
              this.$refs.snackbarqv.print(
                "orange",
                `${JSON.parse(err.response.data.message).result}.`
              );
              this.loading = false;
              reject(err);
            });
        });
      }
    },
    // getFiles() {
    //   var getFiles = {
    //     controller: "Global",
    //     method: "POST",
    //     richiesta: {
    //       action: "getompfile",
    //       token: localStorage.user_token,
    //     },
    //   };

    //   this.$store.dispatch("api", getFiles).then((res) => {
    //     if (res.status == 200) {
    //       this.pdfFiles = res.data.result.files;
    //     }
    //   });
    // },
    goBack() {
      this.uploadNewFiles = false;
      if (this.back_as_landing_page === true) {
        this.$router.push(this.rotta_back).catch(() => {});
      } else {
        this.$emit("click_indietro");
      }
    },
  },
};
</script>